/* je-bg-fx-20260826 — ambient background effects for the BLACK pages we added
   (Will 2026-08-26: "where all the backgrounds are black on the pages we have
   added I want to add effects like we have on the product pages. Think of a
   different one for each").

   One fixed, pointer-events:none <canvas> BEHIND the page (z -1) — the same
   place the product-page effects live — so every white card, dark panel and
   product photo covers it and nothing is ever drawn over content. The page
   shells that paint their own black are made see-through (see the style block
   below); the black body underneath is the site-wide skin. Keyed on
   main[data-template], so a page that is not in MODULES gets nothing at all.

     page.je-showroom-tour  -> spotlights    (shop-window lamps sweeping the floor)
     page.je-dlv-tour       -> headlights    (light trails + road dashes, van-bound)
     page.feedback          -> stars         (rising, twinkling gold stars)
     page.euronics          -> constellation (drifting nodes joining up — the catalogue)
     list-collections       -> bokeh         (soft depth orbs drifting up)
     cart                   -> ribbons       (slow gold/blue light ribbons, low third)
     /collections/deals     -> embers        (warm sparks rising from the floor — Will 2026-08-26 "add one to the deals")
     collection / collection.merged -> gridpulse (dot grid with waves of light passing through — the category grids)
     collection.in-stock    -> sparks        (small lights rising and fading out — the PDP `ember` effect, COPIED.
                                             Will 2026-08-27: "replace the in stock page with the small lights we
                                             have on some of the pages instead of the bubbles… Like the one on
                                             this one", linking a PDP whose dna.module is `ember`. It replaces
                                             `bubbles`, which lived here for half a day and is DELETED, not
                                             switched off — the same call as the `chrome` shader it replaced,
                                             for the same reason: a rejected module left wired in is a loaded gun.
                                             The draw is the tour engine's `flame`/`ember` case character for
                                             character at ember speed; only the count, the palette and the height
                                             ramp are this page's — a PDP canvas is a feature card, this is the
                                             whole viewport, and there is no product palette to read here. NO floor
                                             glow and NO tail: those two are what make Deals' `embers` a fire and
                                             this a field of small lights, on pages a shopper moves between.)
     index (homepage)       -> silk          ("Brand-Blue Silk" — one lit sheet of blue satin under the
                                             page; it was gold until je-silk-blue-20260828.
                                             Will asked for "our best", then rejected the first panel's winner (a
                                             circuit board) as not elegant: "more elegent visually beautiful". Chosen
                                             from a second 4-concept panel (silk / caustics / marble / gold leaf),
                                             2026-08-26 — concepts kept in reports/theme-push/bgfx-20260826/home-concepts-2/.
                                             je-silk-blue-20260828 — Will: "lets make the gold glow on the
                                             homepage a blue glow to match our shop branding. keep it the
                                             same in every other aspect just the colour changes." HUE ONLY:
                                             the gold body/fill and the two warm specular whites become the
                                             brand blue (#2997ff at the same 0.93 peak) and its ices; the
                                             thread and rim were already blue and are untouched. Every
                                             replaced colour keeps its exact max channel, and alpha is
                                             max(r,g,b), so presence, streak coverage and every brightness
                                             number are unchanged by construction. Generated by
                                             reports/theme-push/silk-blue-20260828/patch_blue.py.
                                             je-silk-streak-20260828 — Will: "there should always be a gold
                                             streak across rather than sometimes being a fully black screen".
                                             A void is far wider than the screen, so it switched the WHOLE
                                             frame off: measured, desktop ran 130s of a 209s cycle with no
                                             streak crossing it. The crest-bound light is now re-added by
                                             max(0,RF-env), so a lit pixel is untouched and a voided one
                                             keeps its ribbon. Params + numbers: patch_streak.py.
                                             je-silk-presence-20260827 — Will: "I just dont want it to dissapear
                                             completely sometimes ... Not stronger just more visable." Measured, the sheet
                                             sat at ZERO light over a quarter of a desktop frame and half a phone one, and
                                             the voids doing it barely move: one cell spans ~6 viewport heights of fabric
                                             against a parallax a tenth of the scroll, so a section that landed on one was
                                             dark for its whole height on every visit. The fix is a FLOOR, not a lift:
                                             fill = FILL*(1-smoothstep(0,KNEE,lum)), added after the envelope, so it exists
                                             only below KNEE and is gone above it. Everything that decides how BRIGHT this
                                             is -- body, specular core, sheen, fold field, void size and drift -- is
                                             untouched, because a first attempt that raised those was rejected on sight:
                                             "no I dont want it to be a stronger effect". Two things go wrong here and only
                                             this operator fixes both, since it asks how dark a pixel ENDED UP rather than
                                             why: a void multiplying the sheet to zero, AND a fold flank the single key
                                             light never reached (flooring the envelope alone moved the darkest desktop
                                             tile 0.0036 -> 0.0031, i.e. nowhere). The fill carries a faint fold rhythm so
                                             the dark reads as fabric in shadow, not a plate. Both the shader AND the JS
                                             fallback carry it -- they are two copies of one field. Generated by
                                             reports/theme-push/silk-presence-20260827/patch_silk.py.)

   Deals is keyed on its URL because it renders the same `collection` template as
   /collections/all and any non-merged category — the template alone cannot tell
   them apart.

   Budget: one rAF, DPR capped at 1.5, particle counts scale with viewport area
   and are capped, the loop pauses on a hidden tab, and prefers-reduced-motion
   draws ONE still frame and stops. On the two tour pages -- and ONLY those two
   (RAMP_HERO), because their hero is see-through and carries its own aurora -- the
   effect fades in as the hero scrolls away so the two never stack; the homepage hero
   paints itself opaque black, so it hides the canvas anyway and the ramp there only
   cost presence in the section below it. Revert: scripts/feature_tour/host_bgfx.py --unlink. */
(function () {
  "use strict";
  var MODULES = {
    "page.je-showroom-tour": "spotlights",
    "page.je-dlv-tour": "headlights",
    "page.feedback": "stars",
    "page.euronics": "constellation",
    "list-collections": "bokeh",
    "cart": "ribbons",
    "collection": "gridpulse",
    "collection.merged": "gridpulse",
    "collection.in-stock": "sparks",
    "index": "silk"
  };
  var GOLD = "#f6c71b", BLUE = "#4f8cff", WHITE = "#ffffff", ICE = "#9fd3ff", FLAME = "#ff8a1f";
  // sparks: no product palette on a collection page, so this stands in for the PDP's
  // --pa/--pb/--pc — white and ice carry it and gold is the occasional warm light.
  // Deliberately NOT the warm gold/flame family Deals uses: the two pages sit one
  // click apart and a shopper must be able to tell them apart at a glance.

  // modules that repaint the WHOLE viewport with a "copy" blit: the engine's clear is
  // wasted work for them, and skipping their blit would flash the page black
  var FULL_BLIT = { silk: 1 };

  var main = document.querySelector("main[data-template]");
  if (!main) return;
  var tpl = main.getAttribute("data-template") || "";
  var module = MODULES[tpl];
  // the Deals page is a `collection` too — only its URL tells it apart
  if (tpl.indexOf("collection") === 0 && /^\/collections\/deals(?:\/|$)/.test(window.location.pathname)) module = "embers";
  if (!module) return;
  if (document.getElementById("je-bgfx")) return;
  // je-tour-pagefx-20260827: the PDP runs its own whole-page canvas out of
  // je-tour-engine.js (same z -1 slot, the product's own module). No product.*
  // key exists above so the two cannot collide today — this makes that a guard
  // rather than a coincidence, and the engine checks for #je-bgfx the same way.
  if (document.getElementById("je-tour-bg")) return;

  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* The canvas sits BEHIND the page (z -1), exactly as the product-page effects
     sit behind their content — so white cards, dark panels and product photos
     all cover it and nothing is ever drawn over a photo or a line of copy.
     That only works if the page shell is see-through, and each of these pages
     paints its own black over the body: the tour roots + their #cta, the
     feedback section (colour only — its gradient glows stay), the AtO ghost
     catalogue section, and <main> itself. Those get their background-COLOUR
     cleared here, scoped to the page's own data-template, at a specificity
     that beats the sections' own !important rules. body stays black
     underneath (the site-wide skin), so a page with the script blocked looks
     exactly as it does today. */
  var T = function (tpl) { return "html body main#MainContent[data-template=\"" + tpl + "\"]"; };
  var style = document.createElement("style");
  style.id = "je-bgfx-css";
  style.textContent =
    "#je-bgfx{position:fixed;inset:0;width:100%;height:100%;z-index:-1;pointer-events:none;" +
    "opacity:1;transition:opacity .4s linear}" +
    // je-bgfx-viewport-stable-20260903: cover the URL-bar-RETRACTED viewport, always.
    // height:100% of the ICB is not a fixed quantity on a phone, so during a
    // URL-bar transition the canvas can be shorter than what the user sees and
    // the strip it misses is the body's own black - a full-width black bar at a
    // screen edge that appears and disappears with the scroll direction.  lvh is
    // the viewport with retractable UI retracted, i.e. the tallest it ever gets.
    // bottom:auto is explicit: inset:0 set it, and height wins over it anyway.
    "@supports (height:100lvh){#je-bgfx{height:100lvh;bottom:auto}}" +
    "@media print{#je-bgfx{display:none}}" +
    Object.keys(MODULES).map(T).join(",") + "{background-color:transparent !important}" +
    T("page.je-showroom-tour") + " .je-tour-root," + T("page.je-dlv-tour") + " .je-tour-root," +
    T("page.je-showroom-tour") + " .je-tour-root #cta," + T("page.je-dlv-tour") + " .je-tour-root #cta," +
    T("page.feedback") + " .je-feedback-page," +
    T("page.euronics") + " .section-euronics-ghost-search," +
    // homepage: the tour root + CTA go see-through; #hero and its shop photo
    // deliberately stay opaque black (they own the hero composition), so the
    // effect appears from the Deals section down
    T("index") + " .je-tour-root.je-home," + T("index") + " .je-home #cta{background-color:transparent !important}";
  document.head.appendChild(style);

  var cv = document.createElement("canvas");
  cv.id = "je-bgfx";
  cv.setAttribute("aria-hidden", "true");
  cv.setAttribute("data-module", module);
  document.body.appendChild(cv);
  var ctx = cv.getContext("2d");
  if (!ctx) return;

  var W = 0, H = 0, dpr = 1, parts = [], raf = 0, running = false, lastOpacity = -1;
  var hasHero = !!document.getElementById("hero");
  // je-silk-presence-20260827: only a hero that is SEE-THROUGH and carries its own
  // aurora can stack with this. The homepage hero paints itself opaque black, so it
  // hides the canvas outright and the ramp only cost presence in the section below it
  // (proved: forcing 0.25 -> 1 at scroll 0 on one frozen load changed 0 of 1,296,000 px).
  var RAMP_HERO = { spotlights: 1, headlights: 1 };
  var ramps = hasHero && !!RAMP_HERO[module];

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rgba(hex, a) {
    var n = parseInt(hex.slice(1), 16);
    return "rgba(" + (n >> 16 & 255) + "," + (n >> 8 & 255) + "," + (n & 255) + "," + clamp(a, 0, 1) + ")";
  }
  function count(perPx, lo, hi) {
    return Math.max(lo, Math.min(hi, Math.floor(W * H / perPx)));
  }

  function size() {
    // je-bgfx-phone-dpr-20260904: a phone (coarse pointer, <=820 CSS px) draws the field 1:1 - the fabric and the
    // particles are soft by design, and 1.5x on a DPR-3 phone was 2.25x the fill every frame.
    var jePhone = window.innerWidth <= 820 && !!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
    var d = Math.min(jePhone ? 1 : 1.5, window.devicePixelRatio || 1);
    // je-bgfx-viewport-stable-20260903: the height comes from the CANVAS BOX, never from
    // window.innerHeight.  The box is 100lvh - the viewport with the phone's
    // browser chrome retracted - so it is the one height that does not move when
    // that chrome slides, and the chrome slides on EVERY change of scroll
    // direction.  Measured live at 384x832 before this, driving 832 -> 758 the
    // way Chrome does: one bar-sized change moved 11.87% of the canvas by >12
    // levels in a single step, against 2.46% for 500ms of the field's own drift,
    // because re-deriving asp -> UNITS rescales the fabric (and, on the particle
    // modules, spawn() re-rolls every x/y).  A field is a property of the page;
    // nothing about it is a function of the browser's toolbar.  A genuine resize
    // still re-derives: rotation moves innerWidth, and a desktop window resize
    // moves lvh itself.  No lvh support -> the box is height:100% -> clientHeight
    // is exactly today's innerHeight, so those browsers keep today's behaviour.
    var w = window.innerWidth, h = cv.clientHeight || window.innerHeight;
    if (w === W && h === H && d === dpr) return;
    // a height-only change is the phone's URL bar collapsing on first scroll —
    // stretch what is there rather than respawn, or every particle jumps
    // (a lattice must never be stretched — it respawns, which keeps its rows put)
    // a FULL_BLIT module must never take the stretch path: it returns before spawn(),
    // which would leave its offscreen buffer at the old size and blit a wrong aspect
    var stretch = !FULL_BLIT[module] && module !== "gridpulse" && parts.length && w === W && H > 0 && h !== H ? h / H : 0;
    W = w; H = h; dpr = d;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (stretch) {
      for (var i = 0; i < parts.length; i++) if (typeof parts[i].y === "number") parts[i].y *= stretch;
      return;
    }
    spawn();
  }

  /* ---------------- spawn per module ---------------- */
  function spawn() {
    parts = [];
    var i, n;
    switch (module) {
      case "spotlights":
        // three lamps hung along the top edge, each sweeping its own arc
        parts = [
          { x: 0.18, sway: 0.34, base: 0.10, period: 17000, ph: 0.0, c: GOLD, a: 0.16, w: 0.19 },
          { x: 0.52, sway: 0.28, base: -0.06, period: 23000, ph: 2.1, c: WHITE, a: 0.11, w: 0.15 },
          { x: 0.84, sway: 0.32, base: -0.12, period: 19500, ph: 4.0, c: GOLD, a: 0.14, w: 0.17 }
        ];
        break;
      case "headlights":
        n = count(26000, 22, 70);
        for (i = 0; i < n; i++) parts.push({
          x: rnd(0, W), y: rnd(0, H * 0.92), len: rnd(70, 260), sp: rnd(0.9, 2.4),
          w: rnd(0.8, 2.2), c: i % 4 === 0 ? BLUE : (i % 3 === 0 ? WHITE : GOLD), ph: rnd(0, 6.28)
        });
        break;
      case "stars":
        n = count(14000, 40, 140);
        for (i = 0; i < n; i++) parts.push({
          x: rnd(0, W), y: rnd(0, H), r: rnd(0.9, 2.6), sp: rnd(0.35, 1.1),
          tw: rnd(0.6, 1.6), ph: rnd(0, 6.28), c: i % 5 === 0 ? WHITE : GOLD, spike: Math.random() < 0.35
        });
        break;
      case "constellation":
        n = count(19000, 34, 90);
        for (i = 0; i < n; i++) parts.push({
          x: rnd(0, W), y: rnd(0, H), vx: rnd(-0.12, 0.12), vy: rnd(-0.12, 0.12),
          r: rnd(1.1, 2.4), c: i % 4 === 0 ? BLUE : GOLD, ph: rnd(0, 6.28)
        });
        break;
      case "bokeh":
        n = count(48000, 12, 36);
        for (i = 0; i < n; i++) parts.push({
          x: rnd(0, W), y: rnd(0, H), r: rnd(30, 150), sp: rnd(0.25, 0.9), ph: rnd(0, 6.28),
          c: i % 3 === 0 ? BLUE : (i % 3 === 1 ? WHITE : GOLD), a: rnd(0.18, 0.38)
        });
        break;
      case "ribbons":
        parts = [
          { c: GOLD, a: 0.32, amp: 22, freq: 0.0075, speed: 0.00075, off: 0.72, ph: 0 },
          { c: WHITE, a: 0.16, amp: 30, freq: 0.0058, speed: 0.00062, off: 0.78, ph: 1.7 },
          { c: BLUE, a: 0.20, amp: 26, freq: 0.0066, speed: 0.00088, off: 0.84, ph: 3.3 },
          { c: GOLD, a: 0.14, amp: 36, freq: 0.0049, speed: 0.00052, off: 0.90, ph: 4.6 }
        ];
        break;
      case "embers":
        n = count(16000, 36, 130);
        for (i = 0; i < n; i++) parts.push({
          x: rnd(0, W), y: rnd(0, H), r: rnd(0.8, 2.4), sp: rnd(0.6, 1.6), ph: rnd(0, 6.28),
          c: i % 6 === 0 ? WHITE : (i % 3 === 0 ? FLAME : GOLD)
        });
        break;
      case "gridpulse": {
        // a lattice of dots; the draw pass lights them with two slow travelling waves
        // gap grows on very large screens so the dot count stays ~2k at 4K
        // (44px would be 4,400 arcs a frame); oy is independent of H so a
        // respawn on a height change keeps every existing dot where it was
        var gap = Math.max(W < 700 ? 36 : 44, Math.ceil(Math.sqrt(W * H / 2200)));
        var ox = (W % gap) / 2, oy = gap / 2, ix, iy, x, y;
        for (iy = 0, y = oy; y <= H; y += gap, iy++)
          for (ix = 0, x = ox; x <= W; x += gap, ix++)
            parts.push({ x: x, y: y, c: (ix + iy) % 7 === 0 ? GOLD : ICE, ph: ((ix * 7 + iy * 13) % 20) / 20 });
        break;
      }
      case "silk":
        SILK.spawn();
        break;
      case "sparks":
        // radius + speed are the PDP's own (rnd(0.5,2.2) / rnd(0.4,1.8)) — they are
        // SMALL lights, which is the whole of what Will asked for. The per-pixel
        // density is the PDP's too (its chapter canvas was a 100vh sticky, i.e. already
        // viewport-sized), capped lower so a 4K screen stays inside the frame budget.
        n = count(5200, 40, 300);
        for (i = 0; i < n; i++) parts.push({
          x: rnd(0, W), y: rnd(0, H), r: rnd(0.5, 2.2), sp: rnd(0.4, 1.8), ph: rnd(0, 6.28),
          c: i % 6 === 0 ? GOLD : (i % 2 === 0 ? WHITE : ICE)
        });
        break;
    }
  }

  /* ---------------- primitives ---------------- */
  function dot(x, y, r, c, a) {
    ctx.beginPath(); ctx.fillStyle = rgba(c, a); ctx.arc(x, y, r, 0, 6.2832); ctx.fill();
  }
  function ring(x, y, r, c, a) {
    if (r <= 0) return;
    ctx.beginPath(); ctx.strokeStyle = rgba(c, a); ctx.lineWidth = 1.4;
    ctx.arc(x, y, r, 0, 6.2832); ctx.stroke();
  }
  function glowDisc(x, y, r, c, a) {
    var g = ctx.createRadialGradient(x, y, 0, x, y, r);
    g.addColorStop(0, rgba(c, a)); g.addColorStop(0.55, rgba(c, a * 0.55)); g.addColorStop(1, rgba(c, 0));
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r, 0, 6.2832); ctx.fill();
  }
  function sparkle(x, y, r, c, a) {
    ctx.strokeStyle = rgba(c, a); ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(x - r * 3, y); ctx.lineTo(x + r * 3, y);
    ctx.moveTo(x, y - r * 3); ctx.lineTo(x, y + r * 3);
    ctx.stroke();
  }

  /* ONE WebGL renderer, shared by every shader module — today only `silk`; it also
     drove the In Stock `chrome` sheet until 2026-08-27, when Will replaced that page
     with the copied product-page bubbles (themselves replaced by `sparks` the same
     day) and the shader was deleted. It was two
     byte-identical copies until 2026-08-27 — and they had ALREADY drifted apart:
     one floored its offscreen buffer to stay under the 300k-pixel cap while the
     other rounded and sailed 69 pixels over it. Same failure class as the six
     install-label tables that drifted apart in one codebase. Renders to an
     OFFSCREEN canvas; the caller blits it into the engine's one visible 2D canvas.
     asp/UNITS belong to the calling module, so they are read through getters at
     render time rather than captured. */
  function makeGL(FS, getAsp, getUnits) {
    var VS = "attribute vec2 a;void main(){gl_Position=vec4(a,0.0,1.0);}";
    var c = document.createElement("canvas"), gl = null, u = {}, lost = false, dead = false, iw = 2, ih = 2;
    var OPTS = { alpha: true, antialias: false, depth: false, stencil: false, premultipliedAlpha: true,
                 preserveDrawingBuffer: false, powerPreference: "low-power", failIfMajorPerformanceCaveat: false };
    function sh(type, src) {
      var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { gl.deleteShader(s); return null; }
      return s;
    }
    function init() {
      gl = null; dead = false;
      try { gl = c.getContext("webgl", OPTS) || c.getContext("experimental-webgl", OPTS); } catch (e) { gl = null; }
      if (!gl) { dead = true; return false; }
      var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
      if (!vs || !fs) { dead = true; return false; }
      var prog = gl.createProgram();
      gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { dead = true; return false; }
      gl.useProgram(prog);
      var buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, "a");
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      u.res = gl.getUniformLocation(prog, "u_res");
      u.asp = gl.getUniformLocation(prog, "u_asp");
      u.ph = gl.getUniformLocation(prog, "u_ph");
      u.wp = gl.getUniformLocation(prog, "u_wp");
      u.ev = gl.getUniformLocation(prog, "u_ev");
      u.sy = gl.getUniformLocation(prog, "u_sy");
      u.un = gl.getUniformLocation(prog, "u_un");
      gl.disable(gl.DEPTH_TEST); gl.disable(gl.BLEND);
      gl.viewport(0, 0, iw, ih);
      return true;
    }
    c.addEventListener("webglcontextlost", function (e) { e.preventDefault(); lost = true; }, false);
    c.addEventListener("webglcontextrestored", function () { lost = false; init(); }, false);
    c.addEventListener("webglcontextcreationerror", function () { dead = true; }, false);
    function ok() { return !!gl && !dead && !lost; }
    function resize(w, h) {
      iw = w; ih = h;
      if (c.width !== w || c.height !== h) { c.width = w; c.height = h; }
      if (gl && !lost) gl.viewport(0, 0, w, h);
    }
    function render(ph, wp, ev, sy) {
      gl.uniform2f(u.res, iw, ih);
      gl.uniform1f(u.asp, getAsp());
      gl.uniform4f(u.ph, ph[0], ph[1], ph[2], ph[3]);
      gl.uniform4f(u.wp, wp[0], wp[1], wp[2], wp[3]);
      gl.uniform2f(u.ev, ev[0], ev[1]);
      gl.uniform1f(u.sy, sy);
      gl.uniform1f(u.un, getUnits());
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
    return { canvas: c, init: init, ok: ok, resize: resize, render: render };
  }

  /* ================= SILK — the homepage ("Brand-Blue Silk") =================
     One sheet of brand-blue satin lying under the page, lit from the upper left
     by an ice-white key light and grazed from the lower right by a whisper of
     deeper blue. It is a single continuous height field — a few very large folds at
     shallow diagonals, bent by a slow breathing domain warp — shaded as satin:
     a soft lambert body, a thin icy sheen along every crest, and large soft
     voids drifting through it so roughly half the frame stays quiet and the copy
     mostly sits on the dark -- quiet, but never nothing: a floor added below KNEE
     keeps a trace of blue where the sheet would otherwise reach zero
     (je-silk-presence-20260827). Nothing flickers; the fastest
     crest moves about 8px/s. The fixed viewport sheet is deliberately decoupled
     from document scroll so a fast fling cannot jump the fabric between frames.
     There is no light SOURCE painted anywhere — only a surface and its shading,
     which is what keeps it clear of the aurora, ribbons, bokeh and god-rays.

     Rendering: a WebGL fragment shader on an OFFSCREEN canvas at <=0.5x of the
     DPR-scaled size (capped 300k px), blitted into the engine's ONE 2D canvas
     with "copy" — silk is soft by nature so the bilinear upscale only helps, and
     keeping the visible canvas 2D means getImageData (the QA harnesses) still
     works. Output is premultiplied with alpha = luminance, so the black voids
     are genuinely transparent rather than black-on-black.
     The SHADER RENDER is paced to ~30fps (nothing moves fast enough to need
     more) but the BLIT happens every frame — the engine clears the canvas each
     frame, so skipping the blit would flash the page black.
     No WebGL / no highp / a failed compile / a lost context -> the SAME field is
     computed in JS into a ~12k-pixel ImageData and upscaled (softer, same
     picture). The shader, the fallback and the GL plumbing are lifted verbatim
     from the reviewed concept: reports/theme-push/bgfx-20260826/home-concepts-2/silk.js */
  /* je-silk-soft-20260829: Will, of the blue background effect - "a little more
     blurred around those lines more faded out softer edges" (he declined
     the straight-line revert when asked, so the SHAPE is unchanged).
     Every visible line here is one Gaussian across the fold slope,
     exp(-k*s^2): core 90->50, mid 18->9.5, band 3->2.3,
     sheen2 70->40.  Smaller k = wider = softer.
     ⛔ Widening ALONE makes it brighter - a Gaussian peaks at 1 whatever k
     is, so a lower k only adds light - and "stronger" is the one thing
     Will has already rejected on this effect (je-silk-presence-20260827).
     So every widening is paired with an amplitude cut that holds the
     line's INTEGRAL constant: for exp(-k s^2) that goes as 1/sqrt(k), so
     amp' = amp*sqrt(k'/k) - 0.34->0.2656, 0.20->0.1529, 0.28->0.2504,
     0.12->0.0949.  Same total light, spread wider and lower: blurrier at
     the edge AND more faded at the peak, which is the ask.
     core and mid are cut in BOTH places - the base sheet and the
     je-silk-streak-20260828 re-lit ribbon - or the ribbon inside a void
     ends up brighter than the sheet outside it.
     Generated by reports/theme-push/silk-soft-20260829/patch_soft.py,
     which edits the shader and the JS fallback from ONE table: they are
     two copies of one field and hand-editing one is how they drift. */
  var SILK = (function () {
    var asp = 1.6, UNITS = 4.6, TAU = 6.283185307179586;
    var CAP_GL = 300000, CAP_2D = 12000;
    var RENDER_MS = 31, RENDER_MS_2D = 48;    // shader ~30fps, JS fallback ~20fps
    var lastRender = -1e9, glReady = false, sized = false, wasLive = null;

    // je-silk-shader-compiles-20260830: these two constants MUST carry a decimal
    // point.  GLSL ES 1.00 has no implicit int->float conversion, so
    // `sl*sl*50` is a compile error and the whole shader is rejected --
    // silently, because init() falls through to the JS fallback and nothing
    // logs.  Measured on the live page before this fix: 0 gl drawArrays calls
    // and 129 putImageData calls, i.e. the GPU path had never drawn a frame,
    // costing 2,071ms of main-thread time per homepage load at 4x throttle.
    var FS = [
      "#ifdef GL_FRAGMENT_PRECISION_HIGH",
      "precision highp float;",
      "#define DITHER 1",
      "#else",
      "precision mediump float;",
      "#endif",
      "uniform vec2 u_res;",      // internal resolution
      "uniform float u_asp;",     // css width / height
      "uniform vec4 u_ph;",       // fold phases
      "uniform vec4 u_wp;",       // warp phases
      "uniform vec2 u_ev;",       // envelope phases
      "uniform float u_sy;",      // parallax shift (fabric units)
      "uniform float u_un;",      // fabric units across the viewport width
      "void main(){",
      "  vec2 uv=gl_FragCoord.xy/u_res;",
      "  vec2 p=(uv-0.5)*vec2(u_un,u_un/u_asp);",
      "  p.y-=u_sy;",
      // breathing: two nested low-frequency bends of the sheet
      "  vec2 w=vec2(sin(p.y*0.85+u_wp.x),cos(p.x*0.75+u_wp.y))*0.38",
      "        +vec2(sin(p.y*1.6+p.x*0.4+u_wp.z),sin(p.x*1.4-p.y*0.5+u_wp.w))*0.15;",
      "  vec2 q=p+w;",
      // one height field: a dominant fold family (d1), a crossing one (d2), two ripples
      "  const vec2 d1=vec2(0.42,0.91), d2=vec2(0.62,0.785), d3=vec2(-0.6,0.8), d4=vec2(0.95,-0.31);",
      "  float a1=dot(q,d1)*2.4+u_ph.x, a2=dot(q,d2)*1.5+u_ph.y, a3=dot(q,d3)*3.4+u_ph.z, a4=dot(q,d4)*6.0+u_ph.w;",
      "  float s1=sin(a1), c1=cos(a1), s2=sin(a2), c2=cos(a2), c3=cos(a3), c4=cos(a4);",
      "  vec2 g=2.4*c1*d1+0.525*c2*d2+0.408*c3*d3+0.30*c4*d4;",
      "  vec3 n=normalize(vec3(-g*0.7,1.0));",
      // key light upper-left; blue graze lower-right (pre-normalised)
      "  float dif=max(dot(n,vec3(-0.451,0.551,0.702)),0.0);",
      "  float rim=max(dot(n,vec3(0.701,-0.584,0.409)),0.0); rim*=rim; rim*=rim;",
      // sheen: the line of zero across-slope on every crest of the dominant family. The crossing
      // waves bend and bundle it, so it wanders like a real satin highlight instead of a stripe.
      "  float sl=dot(g,d1)*0.4167;",
      "  float crest=smoothstep(-0.25,0.65,s1);",
      "  float t1=dot(q,vec2(-0.91,0.42));",
      "  float along=0.35+0.65*(0.5+0.5*sin(t1*0.9+u_ph.x*2.0+1.3))*(0.55+0.45*sin(t1*2.3-u_ph.y*3.0));",
      "  float core=exp(-sl*sl*50.0), mid=exp(-sl*sl*9.5), band=exp(-sl*sl*2.3);",
      "  float ca=crest*along;",
      // the satin body: a wide blue glow around each crest, brighter on the flank that faces the key light
      "  float lit=0.45+0.55*smoothstep(0.3,1.0,dif);",
      "  float ridge=band*crest*lit*0.2504;",   // je-silk-streak-20260828: crest-bound, travels with the ribbon
      "  float wash=dif*dif*0.10;",           // broad diffuse sheet - a void is still allowed to take this
      "  float body=ridge+wash;",
      // a fainter, paler thread family running with the folds, only inside the blue — shot silk
      "  float sl2=c2+0.35*c3;",
      "  float sheen2=exp(-sl2*sl2*40.0)*smoothstep(-0.2,0.7,s2)*0.0949*band*band*(0.5+0.5*sin(dot(q,vec2(-0.785,0.62))*1.3+u_ph.z));",
      // presence: very large soft voids of plain black drifting through the sheet
      "  float e=0.7*sin(p.x*0.5+p.y*0.35+u_ev.x)+0.3*sin(p.y*0.9-p.x*0.2+u_ev.y);",
      "  float env=smoothstep(-0.75,0.35,e);",
      "  vec3 c=vec3(0.15,0.55,0.93)*body+vec3(0.98,1.0,1.0)*(core*0.2656*ca)+vec3(0.82,0.95,1.0)*(mid*0.1529*ca)",
      "        +vec3(0.85,0.90,1.0)*sheen2+vec3(0.31,0.55,1.0)*rim*0.12;",
      "  c*=env;",
      // je-silk-streak-20260828: there is ALWAYS a streak. `df` is zero wherever the
      // sheet is lit at all, so this cannot brighten anything that can already be seen;
      // inside a void it re-lights the crest-bound light only, with the bundling term
      // `along` floored so the ribbon cannot be starved by both fields at once.
      "  float df=max(0.0,0.500-env);",
      "  float caR=crest*max(along,0.700);",
      "  c+=(vec3(0.15,0.55,0.93)*ridge+vec3(0.98,1.0,1.0)*(core*0.2656*caR)"
        +"+vec3(0.82,0.95,1.0)*(mid*0.1529*caR)+vec3(0.85,0.90,1.0)*sheen2)*df;",
      // never gone (je-silk-presence-20260827): a floor added ONLY where the sheet has no
      // light of its own, fading to nothing by KNEE so crests, sheen and the median are
      // untouched. A lerped floor under env would have lifted every mid-tone with it --
      // that is a brighter effect, which is not what was asked for.
      "  float lum=max(c.r,max(c.g,c.b));",
      "  float fill=0.05*(1.0-smoothstep(0.0,0.055,lum))*(0.72+0.28*(0.5+0.5*s1));",
      "  c+=vec3(0.15,0.55,0.93)*fill;",
      "#ifdef DITHER",
      "  c+=(fract(sin(dot(gl_FragCoord.xy,vec2(12.9898,78.233)))*43758.5453)-0.5)*(1.0/255.0);",
      "#endif",
      "  c=clamp(c,0.0,1.0);",
      "  gl_FragColor=vec4(c,max(c.r,max(c.g,c.b)));",   // premultiplied; black = transparent
      "}"
    ].join("\n");

    var GL = makeGL(FS, function () { return asp; }, function () { return UNITS; });

    var fb = document.createElement("canvas"), fctx = fb.getContext("2d"), img = null;
    function render2D(ph, wp, ev, sy) {
      if (!fctx) return;
      if (!img || img.width !== fb.width || img.height !== fb.height) img = fctx.createImageData(fb.width, fb.height);
      var fw = fb.width, fh = fb.height, d = img.data, i = 0, x, y;
      var uw = UNITS, uh = UNITS / asp;
      var Lx = -0.451, Ly = 0.551, Lz = 0.702, Rx = 0.701, Ry = -0.584, Rz = 0.409;
      for (y = 0; y < fh; y++) {
        var py = (0.5 - (y + 0.5) / fh) * uh - sy;
        for (x = 0; x < fw; x++) {
          var px = ((x + 0.5) / fw - 0.5) * uw;
          var qx = px + Math.sin(py * 0.85 + wp[0]) * 0.38 + Math.sin(py * 1.6 + px * 0.4 + wp[2]) * 0.15;
          var qy = py + Math.cos(px * 0.75 + wp[1]) * 0.38 + Math.sin(px * 1.4 - py * 0.5 + wp[3]) * 0.15;
          var a1 = (qx * 0.42 + qy * 0.91) * 2.4 + ph[0], a2 = (qx * 0.62 + qy * 0.785) * 1.5 + ph[1];
          var a3 = (qx * -0.6 + qy * 0.8) * 3.4 + ph[2], a4 = (qx * 0.95 + qy * -0.31) * 6.0 + ph[3];
          var s1 = Math.sin(a1), c1 = Math.cos(a1), s2 = Math.sin(a2), c2 = Math.cos(a2), c3 = Math.cos(a3), c4 = Math.cos(a4);
          var gx = 2.4 * c1 * 0.42 + 0.525 * c2 * 0.62 + 0.408 * c3 * -0.6 + 0.30 * c4 * 0.95;
          var gy = 2.4 * c1 * 0.91 + 0.525 * c2 * 0.785 + 0.408 * c3 * 0.8 + 0.30 * c4 * -0.31;
          var nx = -gx * 0.7, ny = -gy * 0.7, inv = 1 / Math.sqrt(nx * nx + ny * ny + 1);
          nx *= inv; ny *= inv;
          var dif = nx * Lx + ny * Ly + inv * Lz; if (dif < 0) dif = 0;
          var rim = nx * Rx + ny * Ry + inv * Rz; if (rim < 0) rim = 0; rim *= rim; rim *= rim;
          var sl = (gx * 0.42 + gy * 0.91) * 0.4167, sl2 = sl * sl;
          var cr = (s1 + 0.25) / 0.9; cr = cr < 0 ? 0 : cr > 1 ? 1 : cr; var crest = cr * cr * (3 - 2 * cr);
          var t1 = qx * -0.91 + qy * 0.42;
          var along = 0.35 + 0.65 * (0.5 + 0.5 * Math.sin(t1 * 0.9 + ph[0] * 2.0 + 1.3)) * (0.55 + 0.45 * Math.sin(t1 * 2.3 - ph[1] * 3.0));
          var core = Math.exp(-sl2 * 50), mid = Math.exp(-sl2 * 9.5), band = Math.exp(-sl2 * 2.3);
          var ca = crest * along, sc = core * 0.2656 * ca, sm = mid * 0.1529 * ca;
          var lt = (dif - 0.3) / 0.7; lt = lt < 0 ? 0 : lt > 1 ? 1 : lt; var lit = 0.45 + 0.55 * lt * lt * (3 - 2 * lt);
          var q2 = c2 + 0.35 * c3, c2r = (s2 + 0.2) / 0.9; c2r = c2r < 0 ? 0 : c2r > 1 ? 1 : c2r;
          var sheen2 = Math.exp(-q2 * q2 * 40) * (c2r * c2r * (3 - 2 * c2r)) * 0.0949 * band * band * (0.5 + 0.5 * Math.sin((qx * -0.785 + qy * 0.62) * 1.3 + ph[2]));
          var e = 0.7 * Math.sin(px * 0.5 + py * 0.35 + ev[0]) + 0.3 * Math.sin(py * 0.9 - px * 0.2 + ev[1]);
          e = (e + 0.75) / 1.1; e = e < 0 ? 0 : e > 1 ? 1 : e; var env = e * e * (3 - 2 * e);
          var ridge = band * crest * lit * 0.2504, wash = dif * dif * 0.10;
          var body = ridge + wash, rr = rim * 0.12;
          var r = (0.15 * body + 0.98 * sc + 0.82 * sm + 0.85 * sheen2 + 0.31 * rr) * env, g = (0.55 * body + sc + 0.95 * sm + 0.90 * sheen2 + 0.55 * rr) * env, b = (0.93 * body + sc + sm + sheen2 + rr) * env;
          // je-silk-streak-20260828 - the same added ribbon as the shader, from the
          // same two numbers in patch_streak.py; these are one field in two copies.
          var df = 0.5 - env; if (df < 0) df = 0;
          if (df > 0) {
            var caR = crest * (along < 0.7 ? 0.7 : along);
            var scR = core * 0.2656 * caR, smR = mid * 0.1529 * caR;
            r += (0.15 * ridge + 0.98 * scR + 0.82 * smR + 0.85 * sheen2) * df;
            g += (0.55 * ridge + scR + 0.95 * smR + 0.90 * sheen2) * df;
            b += (0.93 * ridge + scR + smR + sheen2) * df;
          }
          var lum = r > g ? (r > b ? r : b) : (g > b ? g : b);
          var kt = lum / 0.055; kt = kt < 0 ? 0 : kt > 1 ? 1 : kt;
          var fl = 0.05 * (1 - kt * kt * (3 - 2 * kt)) * (0.72 + 0.28 * (0.5 + 0.5 * s1));
          r += 0.15 * fl; g += 0.55 * fl; b += 0.93 * fl;
          var al = r > g ? (r > b ? r : b) : (g > b ? g : b);
          if (al > 1) al = 1;
          if (al > 0.002) { var s = 255 / al; d[i] = r * s; d[i + 1] = g * s; d[i + 2] = b * s; d[i + 3] = al * 255; }
          else { d[i] = 0; d[i + 1] = 0; d[i + 2] = 0; d[i + 3] = 0; }
          i += 4;
        }
      }
      fctx.putImageData(img, 0, 0);
    }

    function spawn() {
      if (!glReady && !sized) glReady = GL.init();
      sized = true;
      asp = W / Math.max(1, H);
      // fabric units across the width: 4.6 on a landscape screen, 3.3 on a phone,
      // so the folds stay the same size relative to the screen everywhere
      UNITS = clamp(3.3 + 3.25 * (asp - 0.8), 3.3, 4.6);
      // floor, not round: rounding BOTH dimensions carries the buffer over the
      // 300k cap (measured 300,069) — a cap you can exceed is not a cap
      var s = Math.min(0.5, Math.sqrt(CAP_GL / Math.max(1, cv.width * cv.height)));
      GL.resize(Math.max(2, Math.floor(cv.width * s)), Math.max(2, Math.floor(cv.height * s)));
      var s2 = Math.min(0.25, Math.sqrt(CAP_2D / Math.max(1, W * H)));
      fb.width = Math.max(2, Math.round(W * s2)); fb.height = Math.max(2, Math.round(H * s2));
      img = null;   // allocated lazily in render2D — a GL device never reads it
      lastRender = -1e9;
    }

    var ph = [0, 0, 0, 0], wp = [0, 0, 0, 0], ev = [0, 0];
    function phases(s) {
      // rad/s — the fastest term (the big bend, 0.06) moves a crest ~8px/s on a desktop screen
      ph[0] = (s * 0.018) % TAU; ph[1] = (1.7 - s * 0.014) % TAU; ph[2] = (3.1 + s * 0.026) % TAU; ph[3] = (0.6 - s * 0.035) % TAU;
      wp[0] = (s * 0.060) % TAU; wp[1] = (2.2 - s * 0.048) % TAU; wp[2] = (4.0 + s * 0.075) % TAU; wp[3] = (1.1 + s * 0.055) % TAU;
      ev[0] = (0.9 + s * 0.030) % TAU; ev[1] = (2.6 - s * 0.020) % TAU;
    }

    function draw(t) {
      if (!W || !H) return;
      // the engine passes t=0 for the prefers-reduced-motion still frame; a still
      // at t=0 is the field's unbent starting state, so pick a nicer moment
      if (t === 0) t = 20000;
      var live = glReady && GL.ok();
      // a lost OR restored context leaves the buffer we are about to blit EMPTY
      // (a restore hands back a blank drawing buffer; the fallback has never been
      // painted), so force a render on the frame the renderer changes — otherwise
      // the "copy" blit wipes the page background transparent for up to 48ms
      if (live !== wasLive) { lastRender = -1e9; wasLive = live; }
      if (!live && !fctx) return;                 // no GL and no 2D fallback: draw nothing
      var src = live ? GL.canvas : fb;
      if (t - lastRender >= (live ? RENDER_MS : RENDER_MS_2D)) {
        lastRender = t;
        phases(t * 0.001);
        /* je-silk-fast-scroll-stable-20260829: the silk is a fixed viewport
           background, but this sampled raw document scroll only at the shader's
           ~30fps render cadence. A fast fling therefore replaced one fabric
           position with a distant one in a single frame. Keep the approved slow
           time animation and remove only that discontinuous scroll coupling. */
        var sy = 0;
        if (live) GL.render(ph, wp, ev, sy); else render2D(ph, wp, ev, sy);
      }
      // blit EVERY frame: the engine cleared the canvas above us
      ctx.globalCompositeOperation = "copy";
      try { ctx.drawImage(src, 0, 0, W, H); }
      finally { ctx.globalCompositeOperation = "source-over"; }
    }
    return { spawn: spawn, draw: draw };
  })();

  /* ---------------- draw per module ---------------- */
  function draw(t) {
    if (!FULL_BLIT[module]) ctx.clearRect(0, 0, W, H);
    var i, s, x, y, a, k;
    switch (module) {
      case "spotlights": {
        var floorY = H * 0.96;
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          var ang = s.base + Math.sin(t / s.period * 6.2832 + s.ph) * s.sway;   // radians off vertical
          var px = s.x * W, py = -30;
          var L = H * 1.25, half = s.w;
          ctx.save();
          ctx.translate(px, py); ctx.rotate(ang);
          var g = ctx.createLinearGradient(0, 0, 0, L);
          g.addColorStop(0, rgba(s.c, s.a)); g.addColorStop(0.45, rgba(s.c, s.a * 0.5)); g.addColorStop(1, rgba(s.c, 0));
          ctx.fillStyle = g;
          // three nested beams (wide/faint -> narrow/bright) give the cone a soft edge
          // without a canvas blur filter, which is what a phone cannot afford
          var layers = [[1.0, 0.34], [0.7, 0.4], [0.42, 0.5]];
          for (var q = 0; q < 3; q++) {
            var hw = Math.tan(half * layers[q][0]) * L;
            ctx.globalAlpha = layers[q][1];
            ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(-hw, L); ctx.lineTo(hw, L); ctx.closePath(); ctx.fill();
          }
          ctx.globalAlpha = 1;
          ctx.restore();
          // pool of light where the beam meets the floor (canvas y is down, so a
          // positive rotation swings the beam foot to the LEFT)
          var fx = px - Math.tan(ang) * (floorY - py);
          ctx.save(); ctx.scale(1, 0.32);
          glowDisc(fx, floorY / 0.32, Math.tan(half) * (floorY - py) * 1.15, s.c, s.a * 0.9);
          ctx.restore();
        }
        break;
      }
      case "headlights": {
        // light trails travelling left -> right (the van faces right), faster low down
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          var lane = 0.6 + 0.9 * (s.y / H);
          x = (s.x + t * 0.09 * s.sp * lane) % (W + s.len + 80) - s.len - 40;
          y = s.y + Math.sin(t * 0.0006 + s.ph) * 5;
          a = 0.12 + 0.22 * Math.abs(Math.sin(s.ph + t * 0.0011));
          var lg = ctx.createLinearGradient(x, y, x + s.len, y);
          lg.addColorStop(0, rgba(s.c, 0)); lg.addColorStop(0.7, rgba(s.c, a)); lg.addColorStop(1, rgba(WHITE, a * 1.2));
          ctx.strokeStyle = lg; ctx.lineWidth = s.w; ctx.lineCap = "round";
          ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + s.len, y); ctx.stroke();
        }
        // road: a lane of dashes sliding along the bottom edge
        var dashY = H - 26, dashW = 46, gap = 34, shift = (t * 0.12) % (dashW + gap);
        ctx.strokeStyle = rgba(GOLD, 0.22); ctx.lineWidth = 2; ctx.lineCap = "butt";
        ctx.beginPath();
        for (x = -dashW - gap + shift; x < W + dashW; x += dashW + gap) { ctx.moveTo(x, dashY); ctx.lineTo(x + dashW, dashY); }
        ctx.stroke();
        break;
      }
      case "stars": {
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          y = (s.y - t * 0.008 * s.sp) % H; if (y < 0) y += H;
          x = s.x + Math.sin(t * 0.0004 * s.sp + s.ph) * 10;
          k = 0.5 + 0.5 * Math.sin(t * 0.0016 * s.tw + s.ph);          // twinkle 0..1
          a = 0.12 + 0.7 * k * k;
          dot(x, y, s.r * (0.8 + 0.4 * k), s.c, a);
          if (s.spike && k > 0.55) sparkle(x, y, s.r * (k - 0.55) * 2.2, s.c, (k - 0.55) * 1.3);
        }
        break;
      }
      case "constellation": {
        var LINK = Math.min(150, Math.max(90, W * 0.11)), LINK2 = LINK * LINK;
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          s.x += s.vx; s.y += s.vy;
          if (s.x < -10) s.x = W + 10; else if (s.x > W + 10) s.x = -10;
          if (s.y < -10) s.y = H + 10; else if (s.y > H + 10) s.y = -10;
        }
        ctx.lineWidth = 1;
        for (i = 0; i < parts.length; i++) {
          for (var j = i + 1; j < parts.length; j++) {
            var dx = parts[i].x - parts[j].x, dy = parts[i].y - parts[j].y, d2 = dx * dx + dy * dy;
            if (d2 > LINK2) continue;
            a = (1 - Math.sqrt(d2) / LINK) * 0.28;
            ctx.strokeStyle = rgba(ICE, a);
            ctx.beginPath(); ctx.moveTo(parts[i].x, parts[i].y); ctx.lineTo(parts[j].x, parts[j].y); ctx.stroke();
          }
        }
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          a = 0.45 + 0.4 * Math.abs(Math.sin(t * 0.0009 + s.ph));
          dot(s.x, s.y, s.r, s.c, a);
          glowDisc(s.x, s.y, s.r * 5, s.c, a * 0.18);
        }
        break;
      }
      case "bokeh": {
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          y = (s.y - t * 0.006 * s.sp) % (H + s.r * 2); if (y < -s.r) y += H + s.r * 2;
          x = s.x + Math.sin(t * 0.00025 * s.sp + s.ph) * (18 + s.r * 0.4);
          a = s.a * (0.7 + 0.3 * Math.sin(t * 0.0005 + s.ph));
          glowDisc(x, y, s.r, s.c, a);
        }
        break;
      }
      case "ribbons": {
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          var base = H * s.off;
          ctx.beginPath();
          for (x = 0; x <= W; x += 6) {
            y = base + Math.sin(x * s.freq + t * s.speed + s.ph) * s.amp
                     + Math.sin(x * s.freq * 2.7 - t * s.speed * 0.6 + s.ph) * (s.amp * 0.28);
            if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
          }
          ctx.lineCap = "round";
          ctx.strokeStyle = rgba(s.c, s.a * 0.35); ctx.lineWidth = 9; ctx.stroke();   // soft glow
          ctx.strokeStyle = rgba(s.c, s.a); ctx.lineWidth = 1.8; ctx.stroke();        // core line
        }
        break;
      }
      case "embers": {
        // a warm glow along the floor, and sparks that rise out of it, flicker, and die away
        var hg = ctx.createLinearGradient(0, H, 0, H * 0.55);
        hg.addColorStop(0, rgba(FLAME, 0.13)); hg.addColorStop(0.5, rgba(GOLD, 0.05)); hg.addColorStop(1, rgba(GOLD, 0));
        ctx.fillStyle = hg; ctx.fillRect(0, H * 0.55, W, H * 0.45);
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          y = (s.y - t * 0.022 * s.sp) % H; if (y < 0) y += H;
          x = s.x + Math.sin(t * 0.0018 * s.sp + s.ph) * 9 + Math.sin(y * 0.012 + s.ph) * 7;
          k = y / H;                                                         // 1 at the floor, 0 at the top
          // the cards cover most of the lower half on a grid page, so let the
          // sparks stay visible well up the page (k^0.7 rather than k^2)
          a = (0.22 + 0.6 * Math.abs(Math.sin(t * 0.0045 * s.sp + s.ph))) * Math.pow(k, 0.7);
          if (a < 0.015) continue;
          dot(x, y, s.r * (0.7 + 0.6 * k), s.c, a);
          ctx.strokeStyle = rgba(s.c, a * 0.45); ctx.lineWidth = s.r * 0.9; ctx.lineCap = "round";   // short tail
          ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x, y + 4 + s.r * 4 * s.sp); ctx.stroke();
        }
        break;
      }
      case "gridpulse": {
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          var w1 = Math.sin((s.x + s.y) * 0.0055 - t * 0.0009);           // diagonal wave, down-right
          var w2 = Math.sin((s.x - s.y * 0.6) * 0.0075 + t * 0.00055);    // second, slower, crossing it
          k = Math.max(0, (w1 + w2) * 0.5);
          a = 0.16 + 0.6 * k * k + 0.05 * Math.sin(t * 0.002 + s.ph * 6.28);
          dot(s.x, s.y, 1.5 + 1.9 * k, s.c, a);
          if (k > 0.45) glowDisc(s.x, s.y, 9 + 14 * k, s.c, (k - 0.45) * 0.5);   // crest halo
        }
        break;
      }
      case "silk":
        SILK.draw(t);
        break;
      case "sparks": {
        // the tour engine's `ember` case, character for character at ember speed (0.02)
        for (i = 0; i < parts.length; i++) {
          s = parts[i];
          y = (s.y - t * 0.02 * s.sp) % H; if (y < 0) y += H;
          x = s.x + Math.sin(t * 0.002 * s.sp + s.ph) * 8;
          k = y / H;                                   // 1 at the floor, 0 at the top
          // the PDP multiplies by k flat, which on a whole viewport leaves the top half
          // empty — and In Stock has no hero, so that half is on screen from the first
          // pixel. k^0.45 carries the lights the full height and keeps them brighter low.
          a = (0.2 + 0.6 * Math.abs(Math.sin(t * 0.003 * s.sp + s.ph))) * Math.pow(k, 0.45);
          if (a < 0.015) continue;
          dot(x, y, s.r, s.c, a);
        }
        break;
      }
    }
  }

  /* on the tour pages the hero already has its aurora — arrive as it leaves */
  function applyOpacity() {
    var o = 1;
    if (ramps) o = clamp(0.25 + 0.75 * (window.scrollY || 0) / (H * 0.8), 0.25, 1);
    if (Math.abs(o - lastOpacity) > 0.02) { cv.style.opacity = o.toFixed(2); lastOpacity = o; }
  }

  function frame(t) {
    if (!running) return;
    if (W === 0) size();
    raf = window.requestAnimationFrame(frame);
    if (!W || !H) return;   // zero-size viewport: keep polling, draw nothing
    applyOpacity();
    draw(t);
  }
  function start() {
    if (running || reduced) return;
    running = true; raf = window.requestAnimationFrame(frame);
  }
  function stop() {
    running = false;
    if (raf) { window.cancelAnimationFrame(raf); raf = 0; }
  }

  var resizeT = 0;
  window.addEventListener("resize", function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () { size(); if (reduced) { applyOpacity(); draw(0); } }, 120);
  });
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) stop(); else start();
  });

  size();
  if (reduced) { applyOpacity(); draw(0); return; }   // one still frame, no loop
  if (ramps) window.addEventListener("scroll", applyOpacity, { passive: true });
  start();
})();
